"use strict";

svg4everybody();

window.isSafari = false;
var userAgent = navigator.userAgent.toLowerCase(); 
if (userAgent.indexOf('safari') != -1) { 
	if (userAgent.indexOf('chrome') > -1) {
		window.isSafari = false;
	} else {
		window.isSafari = true;
	}
};

if(navigator.userAgent.match(/Trident\/7\./)) { // if IE
	$('body').on("mousewheel", function () {
			// remove default behavior
			event.preventDefault(); 

			//scroll without smoothing
			var wheelDelta = event.wheelDelta;
			var currentScrollPosition = window.pageYOffset;
			window.scrollTo(0, currentScrollPosition - wheelDelta);
	});
}

var 
parseDate = function(timestamp) {
	var _date = new Date();
	
	_date.setTime(timestamp * 1000);
	
	var hours = _date.getHours(),
		minutes = _date.getMinutes(),
		day = ('0' + _date.getDate()).slice(-2),
		month = ('0' + (_date.getMonth() + 1)).slice(-2),
		year = _date.getFullYear();
	return day + "." + month + "." + year;
},

navbarActive = function() {

	// if ($('.navbar .active').length) {
	// 	$('.navbar .active').removeClass('active');
	// }
	// $('.navbar [href="' + document.location.pathname +'"]').addClass('active');
	// if(document.location.hash !== '') {
	// 	$('.navbar [href="' + document.location.pathname + document.location.hash +'"]').addClass('active');
	// 	$('.navbar [href="' + document.location.hash +'"]').addClass('active');
	// }
	// $('.navbar [href="' + document.location.href +'"]').addClass('active');
	
	// $('.navbar .active').each(function(){
	// 	$(this).parents('.dropdown').find('.dropdown-toggle').addClass('active');
	// });

	return true;
},

navbarAffix = function() {
	var _navbar = $('.navbar'),
		_navbarBrand = $('.navbar .navbar-brand');
	if ( window.innerWidth > 767 ) {
		// _navbar.hide();
		$(window).on('scroll resize onload', function() {
			var _scrollTop = parseInt($(window).scrollTop());
			if (_scrollTop > ($('header').height())) {
				_navbar.addClass('affix');
			} else {
				_navbar.removeClass('affix');
				$('.dropdown-menu').dropdown('hide');
			}
		});
	} else {
		// _navbar.show();
		// $(window).on('scroll resize', function() {
		// 	var _scrollTop = parseInt($(window).scrollTop());
		// 	_navbarBrand.stop(true);
		// 	if (_scrollTop > ($('header').height())) {
		// 		_navbarBrand.css({opacity: 1});
		// 	} else {
		// 		_navbarBrand.css({opacity: 0});
		// 	}
		// });
	}
},
// Навигация по якорям
scrollCatalog = function (id, delay){
	var 
		idOffsetTop = Math.round( $(id).offset().top ),
		bodyOffsetTop = $('body').offset().top,
		// paddingTop = ( window.innerWidth <= 767 )? 65 : 5,
		paddingTop = 0,
		sectionMenuTitleHeight = ( $(id).find('.section__menu-title').length )? $(id).find('.section__menu-title').height() : 0,
		_headerHeight = ( $('.header').length )? $('.header').outerHeight(true) : 0,
		_navbarHeight = ( $('.navbar').length )? $('.navbar').outerHeight(true) : 0,
		selectShopWrapHeight = ( $('.select-shop_wrap').length )? $('.select-shop_wrap').height() : 0,
		smartbannerHeight = ( $('#smartbanner').length )? $('#smartbanner').height() : 0,
		$chScrollPositions = Math.round( idOffsetTop - paddingTop + _headerHeight - selectShopWrapHeight - sectionMenuTitleHeight );

	if (delay) { delay = 300; };

	if($('[role="tab"][href="'+ id +'"]').length > 0) {
		var _parentId = $(id).parents('.tab-pane').attr('id');
		if (_parentId !== undefined) {
			$('[href="#'+ _parentId +'"]').tab('show');
		}
		$('[href="'+ id +'"]').tab('show');
		var _tabList = parseInt( $('[role="tab"][href="'+ id +'"]').parents('.tabs__nav').outerHeight(true) );
		paddingTop = (($(id).hasClass('tab-pane'))? (( window.innerWidth > 767 ) ? (_tabList + 44) : 5 ) : 0);
	}

	$('html,body').delay(delay)
		.animate({ 
			// scrollTop: $chScrollPositions 
			scrollTop: Math.round( $(id).offset().top - 55 - paddingTop )
		}, 400, 'swing');

	if( !$('.navbar .navbar-toggler').hasClass('collapsed') ){
		$('.navbar .navbar-toggler').addClass('collapsed');
		$('.navbar-collapse').collapse('hide');
	}

	return true;
},

isInViewport = function(elem) {
	var
		docViewTop = $(window).scrollTop(),
		docViewBottom = docViewTop + $(window).height(),
		elemTop = $(elem).offset().top,
		elemBottom = elemTop + $(elem).height();
	return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
},

trackGAEvent = function(category, label, action){ 
  action = (typeof action === "undefined") ? 'click' : action;
  if (typeof ga !== "undefined") { 
    ga('send', 'event', category, action, label, { 'hitCallback': function(){} }); 
  }
  // console.log('trackGAEvent', label);
  return true;
},
trackOutboundLink = function(url){ 
	trackGAEvent('outbound', url);
},

reachGoal = function(_ID, _TARGET){
  if (typeof ym !== "undefined") {
    ym(_ID, 'reachGoal', _TARGET);
  }
  // console.log('reachGoal', _TARGET);
  return true;
},

goals = function($this) {
	var 
		_ymid = $this.data('ymid'),
		_ymt = $this.data('ymt'),
		_gac = $this.data('gacategory'),
		_gal = $this.data('galabel');
	if (typeof _ymt === "undefined") {} else {
		reachGoal(_ymid, _ymt);
		console.log('reachGoal',_ymt);
	}
	if (typeof _gal === "undefined") {} else {
		trackGAEvent(_gac, _gal);
		console.log('trackGAEvent',_gal);
	}
},

showMap = function() {
  var _map;
  $('#mapShops').css({ height: 450 }).hide();
  function init () {
    var _map = new ymaps.Map("mapShops", {
      // center: [54.985097819556316, 73.35857632528676],
      center: [54.97026898640075, 73.40097751925968],
      zoom: 10,
      // type: "yandex#satellite",
      controls:['zoomControl']
    }, {
      suppressMapOpenBlock: true
    }),
    // searchControl = new ymaps.control.SearchControl({
    //   options: {
    //     provider: 'yandex#search'
    //   }
    // }),
    objectManager = new ymaps.ObjectManager({
      clusterize: false,
      gridSize: 32,
      clusterDisableClickZoom: true,
    });
  
    // _map.controls.add(searchControl);
    // searchControl.search('Hot Омск');

    _map.behaviors.disable('scrollZoom');

    // objectManager.objects.options.set('preset', 'islands#redDotIcon');

    objectManager.objects.options.set('iconLayout', 'default#image');
    objectManager.objects.options.set('iconImageHref', '/assets/front/img/logo-icon-48x48.png');
    objectManager.objects.options.set('iconImageSize', [42, 42]);
    objectManager.objects.options.set('iconImageOffset', [-21, -21]);

    objectManager.clusters.options.set('preset', 'islands#redClusterIcons');
    _map.geoObjects.add(objectManager);

    $.ajax({
      url: "/outlets?map=true",
      dataType: "json"
    }).done(function(data) {
      objectManager.add(data);
      _map.setBounds(objectManager.getBounds());
    });

  }

  $('#mapShops').slideDown('fast', function(){
    ymaps.ready(init);
  });
}

;(function() {

	$.ajaxSetup({ data: { csrf_vh_name:$.cookie("csrf_vh_cookie") } });

	$('._goals')
		.not('form')
		.on('click', function(){
			return goals($(this));
		});

	$('form._goals')
		.on('submit', function(){
			return goals($(this));
		});

	// $('body').scrollspy({ 
	//   target: '#navbarSupportedContent',
	//   offset: 60
	// });

	navbarActive();

	function mainRedirect() {
		window.location.href = "/";
	}

	if ( $('.page-404').length ) {
		setTimeout(mainRedirect, 4000);
	}

	if ( $('[data-inputmask]').length > 0) {
		$('[data-inputmask][type="tel"]').inputmask("+7(999)999-99-99");
	}
	
	if ( $('.alert-success').length > 0) {
		setTimeout(function(){
			$('.alert-success').fadeOut('slow');
		}, 7000);
	}

	if ( $('#map').length > 0 ){
		var mapInit = false;
		$(window).on("scroll resize", function() {
			if(!mapInit && isInViewport($('#map'))) {
				$('#map').css({'min-height': 400});
				mapInit = true;
				var urlMap = 'https://api-maps.yandex.ru/services/constructor/1.0/js/?um=constructor%3A99c130b1382418e7874577126e8606386a8845c50920dbd39aa4255b429f8c9f&amp;width=100%25&amp;height=400&amp;lang=ru_RU&amp;scroll=false&amp;id=map';
				(function(document, tag) {
						var scriptTag = document.createElement(tag),
							firstScriptTag = document.getElementsByTagName(tag)[0];
						scriptTag.src = urlMap;
						firstScriptTag.parentNode.insertBefore(scriptTag, firstScriptTag);
				}(document, 'script'));
			}
		});
	}

	if ( $('#mapShops').length > 0 ){
    var urlApi = '/api/yandex/2.1';
    (function(document, tag) {
        var scriptTag = document.createElement(tag),
          firstScriptTag = document.getElementsByTagName(tag)[0];
        scriptTag.src = urlApi;
        firstScriptTag.parentNode.insertBefore(scriptTag, firstScriptTag);
    }(document, 'script'));

    $('#mapShops')
      .addClass('w-100')
      .addClass('mapShops')
      .addClass('map')
      .html('');

		var mapInit = false;
		$(window).on("scroll resize", function() {
			if(!mapInit && isInViewport($('#mapShops'))) {
				// $('#mapShops').css({'min-height': 450});
        mapInit = true;

        // Показываем карту
        showMap();
      }
		});
  }

	navbarAffix();
	$(window).on('resize', function(){ navbarAffix(); });

	// ### Навигация по якорям // Скролл по хэшу в урле
	var hashData = document.location.hash;
	if ( hashData ) {
		scroll(0,0);
	}

	if ( $(hashData).length > 0 ) {
		// scrollCatalog(hashData);
		$.when( scrollCatalog(hashData) ).done(function(){
			document.location.hash = hashData;
			// document.location.hash = '#';
		});
	}

	$('[role="tab"]').on('click', function(){
		var _id = $(this).attr('href'),
			_parentId = $(_id).parents('.tab-pane').attr('id');
			
		if(!window.isSafari) {
			document.location.hash = _id;
		}
			
		if (_parentId == undefined) {
			if ( window.innerWidth <= 767 ) {
				scrollCatalog(_id);
			}
		}
	});

	$('.navbar-nav .nav-link, .navbar-nav .dropdown-item')
		.not('.dropdown-toggle')
		// .on('click touchstart', function (e){
		.on('click', function (e){
			var self = $(this),
				href = (self.attr('href')).split('#')[1],
				id = '#' + href;

			$('.navbar-collapse').collapse('hide');
			$('.dropdown-menu').dropdown('hide');

			if ( $(id).length > 0 ) {
				e.preventDefault();

				// Скролл к цели и закрыть навигацию
				$.when( scrollCatalog(id) ).done(function(){
					document.location.hash = href;
					// document.location.hash = '#';
					navbarActive();
				});

				return false;
			} else {
				return document.location.href = self.attr('href');
			};
		});

	if ($('[data-lazyload]').length > 0) {
		$('img[data-lazyload="true"],img[data-lazyload="1"]').lazyload();
	}

  // Form on job page
  if ( window.innerWidth > 767 ) {
    $(window).scroll(function() {
      var form = $('.form'),
        scrollTop = parseInt($(window).scrollTop());
        // $('body').height() - $('footer').height() + $('.map').height()
        // сделать нижнюю границу affix

      if (scrollTop > $('header').outerHeight()) {
        form.addClass('affix');
      } else {
        form.removeClass('affix');
      }
    });
  }

	$(function () {
    if ($(window).width() >= 768 && $('.fitness').length > 0) {
        $('a[href^="tel:"]').removeAttr('href');
    }
	});

})();